import {getCustomerBettingStatus, startLoadCustomerDataInterval, stopLoadCustomerDataInterval, getCustomerSegmentStatus} from 'customerActions.js';
import {startSessionTimeInterval, stopSessionTimeInterval} from 'accountActions.js';
import {integrationBetgeniusCreateScript} from 'integrationActions.js';
import {translation, device, browser, generateId} from 'utilsHelper.js';
import {formatDate} from 'datesHelper.js';
import {removeSessionCookie, setAutologinCookies, removeAutologinCookies, getSessionCookie} from 'cookiesHelper.js';
import store from 'store';
import _get from 'lodash/get';
import _omit from 'lodash/omit';

// actions name
export const USER_FROM_COOKIE = 'USER_FROM_COOKIE';
export const USER_SIGNIN = 'USER_SIGNIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOAD_DATA = 'USER_LOAD_DATA';
export const UPDATE_USER_BALANCE = 'UPDATE_USER_BALANCE';
export const UPDATE_BALANCE = 'UPDATE_BALANCE';

// actions creator
const registerUser = (user) => {
    return async(dispatch, getState, {AuthApi}) => {

        // set channel to desktop
        user['channel'] = "desktop";
        // check browser
        user['browser'] = browser();
        // check device
        user['device'] = device();

        try {
            const {code, data, description} = await AuthApi.registerUser(user);

            if (code == 10101) {
                throw {message: translation(`login_api_error_${code}`)};
            } else if (code != 200) {
                throw {message: translation(`login_api_error_${code}`)};
            } else {
                return data;
            }
        } catch ({message}) {
            throw message;
        }
    };
};

const verificationCode = (mobile)=>{
    return async(dispatch, getState, {AuthApi}) =>{
        try {
            const {code, data} = await AuthApi.verificationCode(mobile);
            if (code == 200 && data) {
                return data;
            }
            throw translation(`verificationCode_error`);
        } catch (error) {
            throw error;
        }
    }
};

const preregisterUser = (user) => {
    return async(dispatch, getState, {AuthApi}) => {
        try {
            const {code, data} = await AuthApi.preregisterUser(user);
            if (code == 200) {
                return data;
            }
        } catch (error) {
        }
    }
};

const logInUser = (user) => {

    // set channel to desktop
    user['channel'] = "desktop";
    // check browser
    user['browser'] = browser();
    // check device
    user['device'] = device();

    return async(dispatch, getState, {AuthApi}) => {

        dispatch(signUpUserPending());

        try {

            const hasAutologin = _get(user, ['autologin']);
            if(hasAutologin){
                user = _omit(user, ['autologin']);
                user['uniqueHash'] = generateId(16);
            }
            const {code, data, description} = await AuthApi.logInUser(user);

            if (code == 10101) {
                throw {message: translation(`login_api_error_${code}`)};
            } else if(code == 485){
                let exclusionDate = new Date(description.replace("CEST", "").replace("CET", ""));
                exclusionDate = formatDate(exclusionDate, 'yyyy-MM-dd HH:mm');
                throw {message: translation(`login_api_error_${code}`, [exclusionDate])};

            } else if(code == 403){
              dispatch({
                type: 'TOGGLE_BY_KEY',
                payload: {key: 'TOGGLE_FORBIDDEN_ACCESS_MODAL', isOpen: true}
              });
              throw {message: translation(`access_forbidden`)};
            } else if (code != 200) {
                throw {message: translation(`login_api_error_${code}`)};

            } else {

                const {uniqueHash, passwordHash, accountHash} = data;
                if (uniqueHash && passwordHash && accountHash) {
                    const cookieParams = {uniqueHash, passwordHash, accountHash};
                    setAutologinCookies(cookieParams);
                }

                const checkCustomerRegulations = process.env.CHECK_CUSTOMER_REGULATIONS;
                if (checkCustomerRegulations) {
                    await dispatch(getCustomerBettingStatus());
                }

                dispatch(signUpUserSuccess(data));
                dispatch(startLoadCustomerDataInterval());

                if(CLIENT == 'fuksiarz' || CLIENT == 'etoto'){
                    dispatch(getCustomerSegmentStatus());
                }

                if(CLIENT == 'milenium' || CLIENT == 'fuksiarz' || CLIENT == 'etoto'){
                    dispatch(startSessionTimeInterval());
                }
                if (process.env.BETGENIUS_TAGS_INTEGRATION_SCRIPT == 'true'){
                    integrationBetgeniusCreateScript('loggedin', {AccountID:data.userId});
                }

                return data;
            }
        } catch ({message}) {
            dispatch(signUpUserFailure(message));
            throw message;
        }
    }
};


const logOutUser = () => (dispatch, getState, {AuthApi}) => {

    try{
        const sessionCookie = getSessionCookie();
        AuthApi.logoutUser(sessionCookie);
    }catch(error){
        console.log('logOutUser: ', error)
    }

    dispatch({type: USER_LOGOUT});
    dispatch(stopLoadCustomerDataInterval());

    removeAutologinCookies();

    if(CLIENT == 'milenium' || CLIENT == 'fuksiarz' || CLIENT == 'etoto'){
        dispatch(stopSessionTimeInterval());
    }

    removeSessionCookie();
};

const forgotPassword = (email) => {
    return async(dispatch, getState, {AuthApi}) => {

        try {
            const {code, data, description} = await AuthApi.forgotPassword(email);

            if (code == 10102) {
                throw {message: 'Customer account is not active'};
            } else if (code != 200) {
                throw {message: translation(`error_${code}`)};
            } else {
                if (data == true) {
                    return data;
                } else {
                    throw {message: translation('resetPassword_error')}
                }
            }
        } catch ({message}) {
            throw message;
        }
    }
};


const loadUserFromCookie = () => async(dispatch, getState, {AuthApi}) => {

    dispatch(meFromCookiePending());

    try {
        const [user] = await AuthApi.meFromCookie();
        dispatch(meFromCookieSuccess(user));
        return user;
    } catch (error) {
        dispatch(meFromCookieFailure(error));
        throw error;
    }
};


const changePassword = (passwordData) => {
    return async(dispatch, getState, {AuthApi}) => {
        try {
            const {code, data, description} = await AuthApi.changePassword(passwordData);
            if (code == 200) {
                return data;
            } else if (code == 464) {
                throw {message: translation(`login_api_error_${description}`)};
            } else if (code == 465) {
                throw {message: translation(`api_error_465`)};
            } else {
                throw {message: description};
            }
        } catch ({message}) {
            throw message;
        }
    }
};


const resetPassword = (passwordData) => {
    return async(dispatch, getState, {AuthApi}) => {
        try {
            const {code, data, description} = await AuthApi.resetPassword(passwordData);
            if (code == 200) {
                return data;
            } else if (code == 464) {
                throw {message: translation(`login_api_error_${description}`)};
            } else {
                throw {message: description};
            }
        } catch ({message}) {
            throw message;
        }
    }
};


const isValueUnique = (fieldName, fieldValue) => {
    return async(dispatch, getState, {AuthApi}) => {
        try {
            let fName = (fieldName == 'loginName') ? 'login' : fieldName;
            let fValue = fieldValue;
            const {code, data, description} = await AuthApi.isValueUnique(fName, fValue);
            if (!data) {
                throw `${fName}_isUsed`;
            }

            return data;
        } catch (error) {
            throw error;
        }
    }
};

const smsCodeVerify = (fieldName, fieldValue, mobileNumber) => {
    return async (dispatch, getState, {AuthApi}) => {
        try {
            let fName = fieldName;
            let fValue = fieldValue;
            const {code, data} = await AuthApi.validateSMSCode(fName, fValue, mobileNumber, true);

            if (code == 440) {
                throw {message: `${fName}_wrongAttemptsLimitExceeded`, code};
            } else if(data == false){
                throw `${fName}_wrongSMSCode`;
            }

            return data;
        } catch (error) {
            throw error;
        }
    }
};

const meFromCookieFailure = (error) => {
    return {
        type: `${USER_FROM_COOKIE}_FAILURE`,
        payload: {error}
    }
};

const meFromCookieSuccess = (user) => {
    return {
        type: `${USER_FROM_COOKIE}_SUCCESS`,
        payload: {user}
    }
};

const meFromCookiePending = () => {
    return {
        type: `${USER_FROM_COOKIE}_PENDING`
    }
};

const signUpUserPending = () => {
    return {
        type: `${USER_SIGNIN}_PENDING`
    }
};

const signUpUserSuccess = (user) => {
    return {
        type: `${USER_SIGNIN}_SUCCESS`,
        payload: {user}
    }
};

const signUpUserFailure = (error) => {
    return {
        type: `${USER_SIGNIN}_FAILURE`,
        payload: {error}
    }
};

const updateUserBalance = (data) => {
    return {
        type: UPDATE_USER_BALANCE,
        payload: {data}
    }
};

const isLogged = () => {
    const {getState} = store;
    const {Auth:{isLogged}} = getState();
    return isLogged;
};

export {
    registerUser,
    logInUser,
    logOutUser,
    loadUserFromCookie,
    forgotPassword,
    isLogged,
    isValueUnique,
    changePassword,
    updateUserBalance,
    smsCodeVerify,
    resetPassword,
    preregisterUser,
    verificationCode
};
